import { usePrivy } from '@privy-io/react-auth'

interface PrivyHookResult {
  ready: boolean
  authenticated: boolean
  user: unknown
}

const usePrivyHook = (): PrivyHookResult => {
  const { ready, authenticated, user } = usePrivy()
  const privyState = {
    ready,
    authenticated,
    user,
  }

  return privyState
}

export default usePrivyHook
